import restApi from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApi.post("/api/matl-receipt-plan", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/matl-receipt-plan/csv", params);
};

const upsert = data => {
  return restApi.post("/api/matl-receipt-plan/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/matl-receipt-plan/${ids}`);
};

const materialReceiptPlanService = {
  getAll,
  getAllForCSV,
  upsert,
  remove,
};

export default materialReceiptPlanService;